module.exports = __webpack_public_path__ + "img/login.5ff0b44e.jpg";